import { useMemo } from "react";

import { useAuthState } from "@synthesis/shared-auth";

import { type UserRolesGGE, defaultUserRolesGGE } from "../roles-context";

type RoleRight = keyof UserRolesGGE;

export const useUserRolesGGE = (): UserRolesGGE => {
  const authStore = useAuthState();
  const currentRoles = authStore.currentUser?.roles;

  const roleRight = currentRoles?.find((role: string) => role.startsWith("ПЛАТФОРМА 3Д"))?.split(" ")[2] as RoleRight | undefined;

  return useMemo(() => {
    const roles: UserRolesGGE = { ...defaultUserRolesGGE };

    if (roleRight) {
      roles[roleRight] = true;
    } else {
      roles.НЕТ = true;
    }

    return roles;
  }, [roleRight]);
};
